export default __webpack_public_path__ + "static/media/Logo-Prada.a61f8e63.jpg";